import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import { vuetify, i18n } from "./plugins/vuetify";

createApp(App).use(vuetify).use(router).use(store).use(i18n).mount("#app");
